import { Group } from '@visx/group';
import { HierarchyPointNode } from '@visx/hierarchy/lib/types';
import { truncate } from 'utils/lib';

import { getRelevancyScoreColorLifecycle } from '../../CandidateProgressTable';
import { Employee, NODE_HEIGHT, NODE_WIDTH } from './constants';

type HierarchyNode = HierarchyPointNode<Employee>;

type OrgChartNodeProps = {
  node: HierarchyNode;
  onMouseMove: (event: React.MouseEvent, data: Employee) => void;
  onMouseLeave: (event: React.MouseEvent, data: Employee) => void;
};

export const OrgChartNode = ({ node, onMouseMove, onMouseLeave }: OrgChartNodeProps) => {
  const centerY = -NODE_HEIGHT / 2;
  const avatarWidth = 32;
  const avatarHeight = 32;

  return (
    <Group
      top={node.x}
      left={node.y}
      onMouseMove={(e) => onMouseMove(e, node.data)}
      onMouseLeave={(e) => onMouseLeave(e, node.data)}
    >
      <rect
        height={NODE_HEIGHT}
        width={NODE_WIDTH}
        x={0}
        y={centerY}
        fill="#F5F7F9"
        strokeWidth={1}
        stroke="#EBEFF3"
        rx={8}
      />
      <circle
        cx={24}
        cy={0}
        r={17}
        fill="none"
        stroke={getRelevancyScoreColorLifecycle(node.data.mentorMatch)}
        strokeWidth={3}
      />
      <image
        xlinkHref={node.data.profilePhoto}
        x={8}
        y={centerY + (NODE_HEIGHT - avatarHeight) / 2}
        height={avatarHeight}
        width={avatarWidth}
        clipPath="inset(0% round 50%)"
        preserveAspectRatio="xMidYMid slice"
      />
      <text x={8 + avatarWidth + 8} y={-4} fill="#333" style={{ pointerEvents: 'none', fontSize: '14px' }}>
        {truncate(node.data.name, 19)}
      </text>
      <text x={8 + avatarWidth + 8} y={12} fill="#666" style={{ pointerEvents: 'none', fontSize: '10px' }}>
        {truncate(node.data.role, 27)}
      </text>
    </Group>
  );
};
